import React from 'react';
import { CommonPopup } from 'js/components/common/popups/CommonPopup';

import style from './TransparentPopup.scss';

const classNames = {
    header: style.header,
    inner: style.inner
};

const layerClassNames = {
    overlay: style.overlay
};

export const TransparentPopup = ({ ...props }) => {

    return <CommonPopup
        className={style.popup}
        classNames={classNames}
        layerClassNames={layerClassNames}
        {...props}
    />;
};
